import { reportError, httpContextFromError } from './errorReporter'

export function showSuccessSnackbar(store, message) {
  store.commit('setSnackbar', { type: 'success', message })
}

/**
 * Show an error toast and report it to ops email.
 * @param {object} store
 * @param {string} message
 * @param {{ error?: any, http?: object, kind?: string, extra?: Record<string,string> }} [context]
 */
export function showErrorSnackbar(store, message, context = undefined) {
  store.commit('setSnackbar', { type: 'error', message })
  const http = context?.http || httpContextFromError(context?.error)
  reportError({
    kind: context?.kind || 'ui_error_toast',
    message: String(message || ''),
    error: context?.error,
    http,
    extra: context?.extra,
  })
}

export function bulkCreatedMessage(count, label) {
  return `Successfully added ${count} ${label}.`
}
